import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import List from '@material-ui/core/List'
import AppBar from '@material-ui/core/AppBar'
import classNames from 'classnames'
import { useSnackbar } from 'notistack'
import Toolbar from '@material-ui/core/Toolbar'
import IconButton from '@material-ui/core/IconButton'
import Typography from '@material-ui/core/Typography'
import CloseIcon from '@material-ui/icons/Close'
import Slide from '@material-ui/core/Slide'
import EditIcon from '@material-ui/icons/Edit'
import InputLabel from '@material-ui/core/InputLabel'
import Input from '@material-ui/core/Input'
import FormControl from '@material-ui/core/FormControl'
import Container from '@material-ui/core/Container'
import FormHelperText from '@material-ui/core/FormHelperText'
import { useQuery, useMutation } from '@apollo/react-hooks'
import { userQueries } from '../../graphql/queries'
import { profileMutations } from '../../graphql/mutations'
const useStyles = makeStyles(theme => ({
  appBar: {
    position: 'relative'
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1
  },
  passwordIcon: {
    fontSize: '20px'
  },
  passwordTitle: {
    fontSize: '14px',
    marginLeft: '-15px',
    textTransform: 'uppercase'
  },
  tollbarContainer: {
    paddingLeft: '0 !important',
    paddingRight: '0 !important'
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar
  },
  toolBarRight: {
    marginLeft: 'auto',
    margin: '0 8px'
  },
  iconGrid: {
    fontSize: '16px',
    marginRight: '5px'
  }
}))
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
})
const EditUser = () => {
  const classes = useStyles()
  const { data: dataUser } = useQuery(userQueries.GET_USER)
  const [atualizaUsuario] = useMutation(profileMutations.EDIT_PROFILE)
  const [open, setOpen] = React.useState(false)
  const { enqueueSnackbar } = useSnackbar()
  const [nome = ((dataUser || {}).usuario || {}).nome, setName] = React.useState()
  const [sobrenome = ((dataUser || {}).usuario || {}).sobrenome, setSobrenome] = React.useState()
  const [apelido = ((dataUser || {}).usuario || {}).apelido, setApelido] = React.useState()
  const [errorName, setErrorName] = React.useState(null)
  const [errorLastname, setErrorLastname] = React.useState(null)
  const [errorNickname, setErrorNickname] = React.useState(null)
  const [formTouched, setFormTouched] = React.useState(false)
  const handleClickOpen = () => {
    setOpen(true)
  }
  const handleClose = () => {
    setOpen(false)
  }
  const changeName = e => {
    setName(e.target.value)
    if (!e.target.value) {
      setErrorName('Informe seu nome')
    } else {
      setErrorName('')
    }
  }
  const changeApelido = e => {
    setApelido(e.target.value)
    if (!e.target.value) {
      setErrorNickname('Informe seu apelido')
    } else {
      setErrorNickname('')
    }
  }
  const changeSobrenome = e => {
    setSobrenome(e.target.value)
    if (!e.target.value) {
      setErrorLastname('Informe seu sobrenome')
    } else {
      setErrorLastname('')
    }
  }
  const updateCache = (cache, { data }) => {
    const queryGET_USER = {
      query: userQueries.GET_USER
    }
    const currentUserData = cache.readQuery(queryGET_USER)
    if ((currentUserData || {}).usuario) {
      cache.writeQuery({
        ...queryGET_USER,
        data: {
          ...currentUserData,
          usuario: {
            ...currentUserData.usuario,
            nome,
            sobrenome,
            apelido
          }
        }
      })
    }
    enqueueSnackbar('Usuário atualizado com sucesso')
    setOpen(false)
  }
  const handleSubmit = e => {
    e.preventDefault()
    setFormTouched(true)
    if (nome && sobrenome) {
      return atualizaUsuario({
        variables: {
          nome: nome,
          sobrenome: sobrenome,
          apelido: apelido
        },
        update: updateCache
      })
    }
    if (atualizaUsuario) {
      enqueueSnackbar('Preencha os dados corretamente')
    }
  }
  return (
    <>
      <Button className={classes.buttonColor} color={'primary'} onClick={handleClickOpen}>
        <EditIcon className={classes.iconGrid} /> Editar
      </Button>
      <Dialog fullScreen open={open} onClose={handleClose} TransitionComponent={Transition}>
        <AppBar className={classes.appBar}>
          <Container className={classNames(classes.tollbarContainer)}>
            <Toolbar className={classNames(classes.toolbar)}>
              <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
                <CloseIcon />
              </IconButton>
              <Typography variant="h6" className={classes.title}>
                Editar Perfil
              </Typography>
              <Button className={classNames(classes.toolBarRight)} autoFocus color="inherit" type="submit" onClick={handleSubmit}>
                Salvar
              </Button>
            </Toolbar>
          </Container>
        </AppBar>
        <Container>
          <List>
            <form onSubmit={handleSubmit}>
              <FormControl fullWidth>
                <InputLabel>Nome</InputLabel>
                <Input error={!!errorName && !!formTouched} required type="text" value={nome} name={'nome'} onChange={changeName} />
                <FormHelperText error={!!errorName && !!formTouched}>{errorName}</FormHelperText>
              </FormControl>
              <FormControl fullWidth>
                <InputLabel>Sobrenome</InputLabel>
                <Input
                  error={!!errorLastname && !!formTouched}
                  required
                  type="text"
                  value={sobrenome}
                  name={'sobrenome'}
                  onChange={changeSobrenome}
                />
                <FormHelperText error={!!errorLastname && !!formTouched}>{errorLastname}</FormHelperText>
              </FormControl>
              <FormControl fullWidth>
                <InputLabel>Apelido</InputLabel>
                <Input error={!!errorNickname && !!formTouched} required type="text" value={apelido} name={'apelido'} onChange={changeApelido} />
                <FormHelperText error={!!errorNickname && !!formTouched}>{errorNickname}</FormHelperText>
              </FormControl>
            </form>
          </List>
        </Container>
      </Dialog>
    </>
  )
}
export default EditUser
